import { render, staticRenderFns } from "./FreeDays.vue?vue&type=template&id=55c89cea&"
import script from "./FreeDays.vue?vue&type=script&lang=js&"
export * from "./FreeDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports